import { render, staticRenderFns } from "./tuisong.vue?vue&type=template&id=1795a34e&scoped=true"
import script from "./tuisong.vue?vue&type=script&lang=js"
export * from "./tuisong.vue?vue&type=script&lang=js"
import style0 from "./tuisong.vue?vue&type=style&index=0&id=1795a34e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795a34e",
  null
  
)

export default component.exports